import { useModalContext } from '#pplx/frontend/aether/modals/context/useModalContext.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { useCallback, useMemo } from 'react';
const SpaceSelectModalLazy = Dynamic(async () => {
    const { SpaceSelectModal } = await import('#pplx/frontend/apps/ask/space-select-modal/SpaceSelectModal.js');
    return { default: SpaceSelectModal };
}, {});
export function useSpaceSelectModal({ entryUUID, contextUUID, frontendContextUUID, currentCollectionUuid, currentCollectionSlug, threadAccess, rwToken, }) {
    const { openModal } = useModalContext();
    const openSpaceSelectModal = useCallback(({ mode, threads, omittedSpaces, projectPicker, creationContext, onOptimisticSpaceChange, moveThreadsToSpaceExecutor, }) => {
        const targetThreads = threads ??
            (contextUUID
                ? [
                    {
                        ...(entryUUID ? { entryUUID } : {}),
                        contextUUID,
                        frontendContextUUID,
                        currentCollectionUuid,
                        currentCollectionSlug,
                        threadAccess,
                        rwToken,
                    },
                ]
                : []);
        if (targetThreads.length === 0) {
            logger.warn('[useSpaceSelectModal] missing contextUUID');
            return;
        }
        // For the single-thread fallback, omit the thread's own current space by
        // default. Bulk callers (those passing `threads`) decide for themselves.
        const targetOmittedSpaces = omittedSpaces ?? (!threads && currentCollectionUuid ? [currentCollectionUuid] : undefined);
        openModal(SpaceSelectModalLazy, {
            mode,
            threads: targetThreads,
            omittedSpaces: targetOmittedSpaces,
            projectPicker,
            ...(creationContext ? { creationContext } : {}),
            onOptimisticSpaceChange,
            moveThreadsToSpaceExecutor,
        }, { replace: true });
    }, [
        openModal,
        entryUUID,
        contextUUID,
        frontendContextUUID,
        currentCollectionUuid,
        currentCollectionSlug,
        threadAccess,
        rwToken,
    ]);
    return useMemo(() => ({ openSpaceSelectModal }), [openSpaceSelectModal]);
}
//# sourceMappingURL=useSpaceSelectModal.js.map